import { z } from "zod";
import { supportRequestCapabilitiesSchema } from "./support-request";

/**
 * Playground 会话的 uid。BFF 只为自己发过的这一形状重签，
 * 因为 uid 是令牌的签发输入：放宽它等于把签发口开给任意买家身份。
 */
export const playgroundUidSchema = z
  .string()
  .regex(/^test:[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/);

/**
 * `POST /api/playground/sessions` 的请求体。
 * 带 uid 是续期：同一段对话换一份新令牌。不带是匿名开新会话；New test 带 reset_uid 撤销旧访客再创建。
 */
export const playgroundSessionRequestSchema = z
  .strictObject({
    uid: playgroundUidSchema.optional(),
    reset_uid: playgroundUidSchema.optional(),
  })
  .refine((input) => !input.uid || !input.reset_uid);

export type PlaygroundSessionRequest = z.infer<
  typeof playgroundSessionRequestSchema
>;

/**
 * `POST /api/playground/sessions` 的响应：挂载 Widget 需要的配置。
 * 之后的问答由 Widget 经 Socket 直连 AI 后端，用 `test:` 前缀的 uid 标识，
 * 不进 Inbox、不计指标。
 */
export const playgroundSessionResponseSchema = z.object({
  uid: playgroundUidSchema,
  handshakeUrl: z.string().min(1),
  shopDomain: z.string().min(1),
  /** 与店面握手同一签发核心生成的短期 Widget token。 */
  token: z.string().min(1),
  expires_in: z.number().int().positive(),
  socket_server_url: z.url(),
  voice_gateway_url: z.url().optional(),
  agentName: z.string().min(1),
  capabilities: supportRequestCapabilitiesSchema,
});

export type PlaygroundSessionResponse = z.infer<
  typeof playgroundSessionResponseSchema
>;
